import { Nutrient } from '@/types';

/**
 *
 * Calculate the calories per 100g based it's nutrients
 *
 * Conversion factors come from ANNEX XIV of EU Regulation No 1169/2011 and are for kJ / g
 *
 * Source: https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX:32011R1169#d1e32-47-1
 *
 * TODO: move to ingredient feature
 */
const conversionFactors = {
  carbohydrate: 17,
  carbohydrate_polyols: 10,
  protein: 17,
  fat: 37,
  salatrims: 25,
  alcohol: 27,
  organic_acid: 13,
  fibre: 8,
};

export const calculateCaloriesPer100g = (
  nutrients: Record<Nutrient, number>,
) => {
  const kJs =
    (nutrients.carbohydrate - nutrients.carbohydrate_polyols) *
      conversionFactors.carbohydrate +
    nutrients.carbohydrate_polyols * conversionFactors.carbohydrate_polyols +
    nutrients.protein * conversionFactors.protein +
    nutrients.fat * conversionFactors.fat +
    nutrients.fibre * conversionFactors.fibre;

  const kcals = kJs * 0.239006; // Convert kJ to kcal

  return {
    kcal: kcals,
    kJ: kJs,
  };
};
